import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { RefreshCw, Tag, Eye, Pencil, Trash2, Plus } from "lucide-react";
import { getRiskBadge, CHANNELS } from "./helpers";

export const MyDealsTab = ({ myDeals, myDealsLoading, openDetail, openEdit, confirmDelete, setActiveChannel, isDemo, setFormData, setIsAddOpen, visibleChannels }) => {
  // Filter channels to only show visible ones
  const filteredChannels = visibleChannels 
    ? CHANNELS.filter(c => c.id !== "my_deals" && visibleChannels.includes(c.id))
    : CHANNELS.filter(c => c.id !== "my_deals");

  return (
    <>
      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground">All your created opportunities across categories.</p>
        <p className="text-sm text-muted-foreground font-mono">{myDeals.length} deal{myDeals.length !== 1 ? "s" : ""}</p>
      </div>
      {myDealsLoading ? (
        <div className="flex justify-center py-12"><RefreshCw className="w-6 h-6 animate-spin text-muted-foreground" /></div>
      ) : myDeals.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="my-deals-grid">
          {myDeals.map((opp, index) => (
            <Card key={opp.opportunity_id || index} className="overflow-hidden group hover:border-primary/40 transition-colors cursor-pointer" onClick={() => openDetail(opp)} data-testid={`my-deal-card-${index}`}>
              {opp.image_url && (
                <div className="h-28 overflow-hidden bg-secondary/30">
                  <img src={opp.image_url} alt="" className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity" loading="lazy" />
                </div>
              )}
              <CardContent className={`${opp.image_url ? "pt-4" : "pt-6"} pb-4 space-y-3`}>
                <div>
                  <div className="flex items-center justify-between">
                    <h3 className="font-bold text-sm">{opp.name}</h3>
                    <Badge variant="secondary" className="text-[9px]">{opp.category}</Badge>
                  </div>
                  {opp.description && <p className="text-xs text-muted-foreground mt-0.5 line-clamp-2">{opp.description}</p>}
                </div>
                <div className="flex flex-wrap gap-1.5">
                  {opp.custom_type && <Badge variant="outline" className="text-[10px]">{opp.custom_type}</Badge>}
                  <Badge variant="outline" className="text-[10px] font-mono">{opp.currency || "USD"}</Badge>
                  {getRiskBadge(opp.risk_score)}
                </div>
                <div className="grid grid-cols-2 gap-2 text-xs">
                  {opp.expected_return && (<div className="p-2 bg-secondary/50 rounded"><p className="text-muted-foreground">Expected Return</p><p className="font-mono font-bold text-green-500">{opp.expected_return}</p></div>)}
                  {opp.price && (<div className="p-2 bg-secondary/50 rounded"><p className="text-muted-foreground">Price</p><p className="font-mono font-bold">{opp.price}</p></div>)}
                </div>
                <div className="flex gap-1.5 pt-1" onClick={(e) => e.stopPropagation()}>
                  <Button variant="ghost" size="sm" className="text-xs gap-1" onClick={() => openDetail(opp)}><Eye className="w-3 h-3" /> Details</Button>
                  <Button variant="ghost" size="sm" className="text-xs gap-1" onClick={() => openEdit(opp)}><Pencil className="w-3 h-3" /> Edit</Button>
                  <Button variant="ghost" size="icon" className="ml-auto h-7 w-7" onClick={() => confirmDelete(opp)}><Trash2 className="w-3.5 h-3.5 text-destructive" /></Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      ) : (
        <div className="space-y-4">
          <Card>
            <CardContent className="py-8 text-center">
              <Tag className="w-10 h-10 text-muted-foreground mx-auto mb-3" />
              <p className="font-medium mb-1">No deals saved yet</p>
              <p className="text-sm text-muted-foreground mb-6">Browse opportunities and save them here, or create your own</p>
            </CardContent>
          </Card>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {filteredChannels.map((ch) => {
              const Icon = ch.icon;
              return (
                <Card key={ch.id} className="cursor-pointer hover:border-primary/60 transition-all hover:scale-[1.02] group" onClick={() => setActiveChannel(ch.id)} data-testid={`browse-${ch.id}`}>
                  <CardContent className="py-6 text-center">
                    <Icon className="w-8 h-8 text-muted-foreground group-hover:text-primary transition-colors mx-auto mb-2" />
                    <p className="font-bold text-sm">{ch.name}</p>
                    <p className="text-[10px] text-muted-foreground mt-0.5">{ch.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};
